import { useCallback } from "react"
import { PropTypes } from "prop-types"
import isEmpty from "lodash/isEmpty"

import useFastField from "../useFastField"
import SelectField from "."

/**
 * Wrapper for the SelectField component to let Formik handle the form state
 *
 * @export {function} SelectFieldWrapper
 * @param {object} props SelectFieldWrapper props
 * @returns {function} SelectFieldWrapper
 */
export default function SelectFieldWrapper({ name, ...rest }) {
  const { field, error, helpers, touched } = useFastField(name)
  const { setTouched, setValue } = helpers

  const onBlur = useCallback(() => setTouched(), [setTouched])
  const onChange = useCallback(value => setValue(value), [setValue])

  let checkedError = error

  if (!isEmpty(field.value)) {
    checkedError = { hasError: false }
  }

  return (
    <SelectField
      {...field}
      error={checkedError}
      name={name}
      selectedValue={field.value}
      onBlur={onBlur}
      touched={field.value ? touched : false}
      onChange={onChange}
      {...rest}
    />
  )
}

SelectFieldWrapper.propTypes = {
  name: PropTypes.string.isRequired
}
